import React from 'react';

export default function Spinner(props) {
  return (
    <span
      className={'spinner' + (props.light ? ' spinner--light' : '')}
      aria-hidden="true"
    />
  );
}
